import template from './routes.html';
import controller from './routes.controller';
import './routes.scss';

let routesComponent = {
  restrict: 'E',
  bindings: {
    acl: '=',
    hasACL: '='
  },
  template,
  controller
};

export default routesComponent;


// WEBPACK FOOTER //
// ./client/app/components/routes/routes.component.js